import { Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TagTable } from '../Table';

import { CustomRemoveTagEmptyTable } from './CustomRemoveTagEmptyTable';
import * as S from './style';

function RemoveTagsTable({ selectedRows = {}, totalTagData = [], onChangeSelectedRows }) {
  const { t } = useTranslation();

  return (
    <S.AddTagsWrapper>
      <S.TableHeader>
        <S.TitleWrapper>
          <Typography variant="body2Bold">{t('tagsIncluded')}</Typography>
          <VerticalDivider $height="24px" $margin="0 12px" />
          <Typography variant="body2">
            <Trans
              i18nKey="totalTags"
              values={{ count: totalTagData?.length || 0 }}
              components={{ b: <b /> }}
            />
          </Typography>
        </S.TitleWrapper>
      </S.TableHeader>

      <TagTable
        selectable
        selectedRows={selectedRows}
        defaultParams={{
          filters: {
            ids: totalTagData
          },
          enabled: totalTagData?.length > 0
        }}
        components={{
          EmptyTable: CustomRemoveTagEmptyTable
        }}
        onChangeSelectedRows={onChangeSelectedRows}
      />
    </S.AddTagsWrapper>
  );
}

export { RemoveTagsTable };
